import { render, staticRenderFns } from "./Get_public.vue?vue&type=template&id=59f2fd64"
import script from "./Get_public.vue?vue&type=script&lang=js"
export * from "./Get_public.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports